import React from "react";

const MySQLIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 255.995 255.995"
    >
      <path
        fill="#00758f"
        strokeMiterlimit="10"
        d="M3.125 1c-.906 0-1.622.48-1.96 1.313-.108.256-.162.529-.163.81-.001.931.599 1.687.959 2.139.063.079.12.15.18.234l.162.215c.16.21.344.45.402.57.02.055.044.152.078.274.157.565.45 1.615.916 2.414.188.322.453.726.643 1.011C4.215 10.616 4 11.788 4 12.5c0 1.25.26 2.254.824 3.172C5.034 16 5.671 17 6.75 17c.383 0 1.02-.15 1.191-1.1C8.706 16.887 10 18.125 12 19c0 0-3.75-4.375-4.408-7.102 0 0-.717.727-1.326 2.211C6.084 13.651 6 13.135 6 12.5c0-.627.276-2.029.383-2.516l.094-.423-.247-.358c-.004-.007-.507-.734-.802-1.24-.336-.576-.584-1.467-.717-1.945a4.78 4.78 0 00-.164-.516c-.175-.379-.431-.712-.656-1.006l-.125-.166a6.297 6.297 0 00-.24-.314c-.184-.23-.524-.659-.514-.934l.111-.078L3.125 3c.795 0 1.82.564 2.205.777.126.07.219.117.268.14l.174.075.341.012c.447.01 1.806.042 2.766.426 1.75.7 2.72 1.4 3.703 2.68 2.324 3.021 3.181 6.935 3.19 6.974l.124.564.547.178c.02.007 1.55.519 2.977 1.856C17.625 17.126 17 18 17 18s.476.928 2.75 2.375c1.375.875 2.125 1.5 3.25 2.625 0 0-1.124-2.5-2.695-4.492 1.196-.383 2.666-.582 2.666-.582l-.91-1.262c-1.498-2.077-3.507-3.125-4.463-3.533-.332-1.266-1.335-4.516-3.43-7.24-1.199-1.56-2.475-2.492-4.547-3.32-1.227-.49-2.702-.55-3.36-.565C5.688 1.69 4.41 1 3.126 1zm4.063 4s-.438 0-.938.125l1.375 1.873C8 6.5 8 5.918 8 5.918S7.75 5.25 7.187 5z"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        transform="scale(10.66667)"
      ></path>
    </svg>
  );
};

export default MySQLIcon;
